import { Component } from '@angular/core';

import { ToastController, AlertController, NavParams, ViewController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';

import { PaymentService } from '../../../../services/payment.service';

@Component({
    selector: 'payment-details',
    templateUrl: 'payment-details.html'
})
export class PaymentDetailsPage {
    title: any;
    entry: any;
    details: any;

    loadingData: boolean;

    constructor(navParams: NavParams, private alert: AlertMessager, private toast: ToastController, 
        private paymentService: PaymentService, private viewController: ViewController, private alertController: AlertController) {
        this.entry = navParams.get('entry');
        this.details = navParams.get('details');

        console.log('details: ', this.details);
    }

    refund() {
        if (this.loadingData)
            return;

        this.loadingData = true;

        let alert = this.alertController.create({
            title: 'Confirm Payment Refund',
            message: 'Do you want to refund this payment?',
            buttons: [
            {
                text: 'Yes',
                handler: () => {
                    this.paymentService.refundEntry(this.entry.id, this.details.transaction.lineItems[0].unitPrice, this.entry.payConfirmation)
                    .then(data => {
                        this.loadingData = false;
                        this.toast.create({
                            message: 'Payment was refunded successfully.',
                            duration: 1500,
                            position: 'middle'
                        }).present();
                    }).catch(error => {
                        this.loadingData = false;
            
                        this.alert.showError("Refund Error", "Refund failed to process.  Please contact NextGenRodeo.");
                    });
                }
            },
            {
                text: 'No',
                role: 'cancel',
                handler: () => { }
            }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.loadingData = false;
        })
    }

    cancel() {
        this.viewController.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/entries/payment-details.ts